/* Jerzify shopping layer on top of Edge: size guide, "Make it yours" add-ons,
   bag add-ons, and private one-person offers. Context comes from window.jzCtx (layout/theme.liquid). */
(function () {
  var C = window.jzCtx || {};
  var T = C.t || {};
  var money = function (c) {
    var f = (C.moneyFormat || '${{amount}}');
    var v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var ses = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  /* re-render the bag (and open it) from fresh section HTML */
  function refreshBag(sections) {
    var d = drawer();
    var go = sections ? Promise.resolve(sections) : fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
    return go.then(function (s) {
      if (d && d.renderContents && s['cart-drawer']) { d.classList.remove('is-empty'); d.renderContents({ sections: s }); }
      else location.href = C.cartUrl || '/cart';
    });
  }
  function addItems(items) {
    return post((C.root || '/') + 'cart/add.js', { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      .then(function (r) { return refreshBag(r.sections); });
  }
  function normSize(s) {
    var t = String(s || '').toUpperCase().replace(/[^A-Z0-9.]/g, '');
    var m = t.match(/^(X{2,})L$/); if (m) return m[1].length + 'XL';
    return ({ SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL' })[t] || t;
  }
  function sectionOf(el) { return el.closest('.shopify-section, section') || document; }
  function radiosFor(root, name) {
    return Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'), function (r) { return r.name === name; });
  }
  function current(root, name) {
    var r = radiosFor(root, name).filter(function (x) { return x.checked; })[0];
    if (r) return r.value;
    var s = root.querySelector('select[name="options[' + name + ']"]');
    return s ? s.value : '';
  }
  function choose(root, name, value) {
    var key = normSize(value);
    var r = radiosFor(root, name).filter(function (x) { return normSize(x.value) === key; })[0];
    if (r) { r.click(); return true; }
    var s = root.querySelector('select[name="options[' + name + ']"]');
    if (s) {
      var o = Array.prototype.filter.call(s.options, function (x) { return normSize(x.value) === key; })[0];
      if (o) { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    }
    return false;
  }

  /* ---------- size guide ---------- */
  function sizeGuide(box) {
    if (box.__jz) return; box.__jz = true;
    var modal = box.closest('modal-dialog');
    // Edge may lift the popup to <body>; the size buttons then live in the product section
    var root = document.querySelector('.product__info-container') ? sectionOf(document.querySelector('.product__info-container')) : sectionOf(modal || box);
    var opt = box.getAttribute('data-option') || 'Size';
    var vopt = box.getAttribute('data-version-option');
    var kind = box.getAttribute('data-kind');
    var result = box.querySelector('[data-sg-result]');
    var pick = null;
    function pane() { return box.querySelector('[data-sg-pane].is-on') || box.querySelector('[data-sg-pane]'); }
    function show(name) {
      box.querySelectorAll('[data-sg-pane]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-sg-pane') === name); });
      box.querySelectorAll('[data-sg-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-sg-tab') === name); });
      mark(); find();
    }
    function mark() {
      var cur = normSize(current(root, opt));
      box.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.classList.toggle('is-cur', !!cur && normSize(tr.getAttribute('data-size')) === cur);
        tr.classList.toggle('is-pick', !!pick && tr === pick);
      });
    }
    function num(k) { var i = box.querySelector('[data-sg-in="' + k + '"]'); var v = i ? parseFloat(i.value) : NaN; return isNaN(v) ? null : v; }
    function find() {
      var rows = Array.prototype.slice.call(pane().querySelectorAll('tbody tr'));
      var h = num('height'), w = num('weight'), f = num('foot');
      pick = null;
      if (kind === 'shoes') {
        if (f) pick = rows.filter(function (r) { return parseFloat(r.getAttribute('data-foot')) >= f; })[0] || rows[rows.length - 1];
      } else if (h || w) {
        var ih = 0, iw = 0;
        if (h) { ih = rows.findIndex(function (r) { return h <= parseFloat(r.getAttribute('data-h')); }); if (ih < 0) ih = rows.length - 1; }
        if (w && rows[0].getAttribute('data-w')) { iw = rows.findIndex(function (r) { return w <= parseFloat(r.getAttribute('data-w')); }); if (iw < 0) iw = rows.length - 1; }
        pick = rows[Math.max(ih, iw)];
      }
      if (!pick) { result.hidden = true; mark(); return; }
      var size = pick.getAttribute('data-size');
      result.hidden = false;
      box.querySelectorAll('[data-sg-size]').forEach(function (b) { b.textContent = size; });
      box.querySelector('[data-sg-say]').textContent = T.sg_say || 'Your size:';
      var tip = '';
      var pn = pane().getAttribute('data-sg-pane');
      if (pn === 'player') tip = T.sg_tip_player || '';
      else if (kind === 'shoes') tip = T.sg_tip_shoes || '';
      else tip = T.sg_tip || '';
      box.querySelector('[data-sg-tip]').textContent = tip;
      var has = radiosFor(root, opt).length || root.querySelector('select[name="options[' + opt + ']"]');
      box.querySelector('[data-sg-choose]').hidden = !has;
      mark();
    }
    box.addEventListener('input', function (e) { if (e.target.matches('[data-sg-in]')) { store.set('jz_fit', { h: num('height'), w: num('weight'), f: num('foot') }); find(); } });
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sg-tab]'); if (t) { show(t.getAttribute('data-sg-tab')); return; }
      var tr = e.target.closest('tbody tr'); if (tr) { choose(root, opt, tr.getAttribute('data-size')); setTimeout(mark, 60); return; }
      if (e.target.closest('[data-sg-choose]') && pick) {
        choose(root, opt, pick.getAttribute('data-size'));
        setTimeout(function () { mark(); var x = modal && modal.querySelector('.modal__close-btn, [id^="ModalClose"]'); if (x) x.click(); else if (modal && modal.hide) modal.hide(); }, 120);
      }
    });
    // remember what they typed last time
    var fit = store.get('jz_fit', null);
    if (fit) {
      ['height', 'weight', 'foot'].forEach(function (k) { var i = box.querySelector('[data-sg-in="' + k + '"]'); var v = fit[k === 'height' ? 'h' : k === 'weight' ? 'w' : 'f']; if (i && v) i.value = v; });
    }
    // follow the chosen version (Fan / Player)
    if (vopt && box.querySelector('[data-sg-tab]')) {
      var v = (current(root, vopt) || '').toLowerCase();
      if (v.indexOf('player') === 0) show('player');
    }
    root.addEventListener('change', function () {
      setTimeout(function () {
        if (vopt && box.querySelector('[data-sg-tab]')) {
          var v = (current(root, vopt) || '').toLowerCase();
          var want = v.indexOf('player') === 0 ? 'player' : (v.indexOf('fan') === 0 ? 'fan' : null);
          if (want && pane().getAttribute('data-sg-pane') !== want) show(want);
        }
        mark();
      }, 60);
    });
    find();
  }

  /* ---------- "Make it yours": name + number, patches, gift box ---------- */
  function custom(box) {
    if (box.__jz) return; box.__jz = true;
    var root = sectionOf(box);
    var print = box.querySelector('[data-jzx-print]');
    var nm = box.querySelector('[data-jzx-name]'), no = box.querySelector('[data-jzx-num]');
    var pv = box.querySelector('[data-jzx-preview]');
    var boxIn = box.querySelector('[data-jzx-box]');
    var total = box.querySelector('[data-jzx-total]');
    var picked = box.querySelector('[data-jzx-picked]');
    function extras() {
      var c = 0;
      if (print && ((nm && nm.value.trim()) || (no && no.value.trim()))) c += +print.getAttribute('data-fee-price') || 0;
      box.querySelectorAll('[data-jzx-patch][aria-pressed="true"]').forEach(function (b) { c += +b.getAttribute('data-price') || 0; });
      if (boxIn && boxIn.checked) c += +boxIn.getAttribute('data-price') || 0;
      return c;
    }
    function paint() {
      if (pv) {
        var a = nm ? nm.value.trim() : '', b = no ? no.value.trim() : '';
        pv.hidden = !(a || b);
        pv.querySelector('[data-jzx-pv-name]').textContent = a;
        pv.querySelector('[data-jzx-pv-num]').textContent = b;
        pv.querySelector('[data-jzx-pv-name]').style.fontSize = a.length > 8 ? Math.max(7, 12 - (a.length - 8)) + 'px' : '';
      }
      var on = box.querySelectorAll('[data-jzx-patch][aria-pressed="true"]');
      if (picked) {
        var pc = 0; on.forEach(function (x) { pc += +x.getAttribute('data-price') || 0; });
        picked.textContent = on.length ? on.length + ' · +' + money(pc) : picked.getAttribute('data-empty');
        picked.classList.toggle('is-set', on.length > 0);
      }
      var pv2 = box.querySelector('[data-jzx-print-v]');
      if (pv2 && print) {
        var nn = nm ? nm.value.trim() : '', nb = no ? no.value.trim() : '';
        pv2.textContent = (nn || nb) ? [nn, nb].filter(Boolean).join(' ') + ' · +' + money(+print.getAttribute('data-fee-price') || 0) : '+' + money(+print.getAttribute('data-fee-price') || 0);
        pv2.classList.toggle('is-set', !!(nn || nb));
      }
      var x = extras();
      if (total) { total.hidden = !x; total.textContent = (T.cx_extras || 'Extras') + ' +' + money(x); }
      box.classList.toggle('has-extras', x > 0);
    }
    if (nm) nm.addEventListener('input', function () { nm.value = nm.value.replace(/[^a-zA-Z .'-]/g, '').toUpperCase(); paint(); });
    if (no) no.addEventListener('input', function () { no.value = no.value.replace(/\D/g, '').slice(0, 2); paint(); });
    if (boxIn) boxIn.addEventListener('change', paint);
    box.addEventListener('click', function (e) {
      var p = e.target.closest('[data-jzx-patch]'); if (!p) return;
      p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); paint();
    });
    box.__extras = extras;
    // take over the add only when an extra is chosen; otherwise Edge adds as usual.
    // Listening on document in the capture phase runs before Edge's own submit handler.
    var form = root.querySelector('product-form:not(.jzc__form) form');
    if (!form || form.__jzx) return; form.__jzx = true;
    // the jersey plus its extras, as /cart/add.js items (also used by "Buy now")
    box.__items = function (fd) {
      var vid = String(fd.get('id'));
      var qty = parseInt(fd.get('quantity') || 1, 10) || 1;
      var item = { id: +vid, quantity: qty, properties: {} };
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) item.properties[m[1]] = v; });
      var pid = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var adds = [];
      var a = nm ? nm.value.trim() : '', b = no ? no.value.trim() : '';
      if (print && (a || b)) {
        if (a) item.properties.Name = a;
        if (b) item.properties.Number = b;
        var fp = {}; if (a) fp.Name = a; if (b) fp.Number = b;
        adds.push({ id: +print.getAttribute('data-fee-id'), properties: fp });
      }
      var pk = Array.prototype.slice.call(box.querySelectorAll('[data-jzx-patch][aria-pressed="true"]'));
      if (pk.length) {
        item.properties.Patches = pk.map(function (x) { return x.getAttribute('data-name'); }).join(', ');
        pk.forEach(function (x) { adds.push({ id: +x.getAttribute('data-jzx-patch'), properties: {} }); });
      }
      if (boxIn && boxIn.checked) adds.push({ id: +boxIn.getAttribute('data-jzx-box'), properties: { 'Packaging for': box.getAttribute('data-title') || '' } });
      item.properties._pid = pid;
      // the bag lists the newest line first: send the extras first so they sit under their jersey
      return adds.map(function (x) { x.properties._for = vid; x.properties._pid = pid; return { id: x.id, quantity: qty, properties: x.properties }; }).reverse().concat([item]);
    };
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !extras()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]'); if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      var items = box.__items(new FormData(form));
      addItems(items)
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to bag'); })
        .then(function () { if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); } });
    }, true);
    paint();
  }

  /* ---------- Buy now: same add as the button, then straight to checkout ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jz-buynow]'); if (!b) return;
    var root = sectionOf(b);
    var form = root.querySelector('product-form:not(.jzc__form) form'); if (!form) return;
    if (form.reportValidity && !form.reportValidity()) return;
    var fd = new FormData(form);
    var box = root.querySelector('[data-jz-custom]');
    var items = box && box.__items ? box.__items(fd) : (function () {
      var it = { id: +fd.get('id'), quantity: parseInt(fd.get('quantity') || 1, 10) || 1, properties: {} };
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) it.properties[m[1]] = v; });
      return [it];
    })();
    b.classList.add('is-busy'); b.disabled = true;
    post((C.root || '/') + 'cart/add.js', { items: items })
      .then(function () { location.href = (C.root || '/') + 'checkout'; })
      .catch(function (err) { b.disabled = false; b.classList.remove('is-busy'); alert((err && (err.description || err.message)) || 'Could not add to bag'); });
  });

  /* ---------- review wall: show the rest ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jz-wall-more]'); if (!b) return;
    var wall = b.closest('[data-jz-wall]');
    wall.querySelectorAll('.jzw__item.is-later').forEach(function (li) { li.classList.remove('is-later'); });
    b.parentNode.remove();
  });

  /* ---------- review photos open full size ---------- */
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-jz-zoom]'); if (!z) return;
    var d = document.createElement('dialog'); d.className = 'jz-zoom';
    d.innerHTML = '<img src="' + z.getAttribute('data-jz-zoom') + '" alt="" width="1200" height="1200">';
    document.body.appendChild(d);
    d.addEventListener('click', function () { d.close(); d.remove(); });
    d.addEventListener('close', function () { d.remove(); });
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  });

  /* ---------- bag: one-tap add-ons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jz-bag-plus]'); if (!b) return;
    var card = b.closest('[data-jz-bag-add]'); var v = card && card.querySelector('[data-jz-bag-variant]');
    if (!v || !v.value) return;
    b.classList.add('is-busy'); b.disabled = true;
    addItems([{ id: +v.value, quantity: 1 }]).catch(function () { b.disabled = false; b.classList.remove('is-busy'); });
  });

  /* ---------- private one-person offers ----------
     A code made in Shopify admin, offered only to a shopper who shows a real signal:
     lingering in the bag, coming back to the same product, leaving with a full bag,
     or returning to a bag they left. One offer per shopper per cooldown; the countdown is real
     (when it ends the code is taken off the bag again). */
  var O = C.offer || {};
  var KEY = 'jz_offer';
  var st = store.get(KEY, { v: {} });
  st.v = st.v || {};
  function save() { store.set(KEY, st); }
  function now() { return Date.now(); }
  function live() { return !!(O.code && st.exp && now() < st.exp); }
  function cooling() { return !!(st.at && !live() && now() - st.at < (O.cooldown || 14) * 864e5); }
  function grant(why) {
    if (!O.code) return false;
    if (live()) return true;
    if (cooling()) return false;
    st.at = now(); st.exp = now() + (O.minutes || 20) * 6e4; st.why = why; st.applied = false; save();
    paintOffer(); tick();
    return true;
  }
  function left() { var s = Math.max(0, Math.round((st.exp - now()) / 1000)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function cartJS() { return fetch((C.root || '/') + 'cart.js').then(function (r) { return r.json(); }); }
  function apply(then) {
    var code = O.code;
    return post((C.root || '/') + 'cart/update.js', { discount: code, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      .then(function (c) {
        var d = (c.discount_codes || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
        if (d && d.applicable === false) throw new Error('na');
        if (!c.item_count) return fetch((C.root || '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent((C.root || '/') + 'cart.js')).then(function () { st.applied = true; save(); });
        st.applied = true; save();
        if (then === 'checkout') { location.href = (C.root || '/') + 'checkout?discount=' + encodeURIComponent(code); return; }
        return refreshBag(c.sections);
      })
      .catch(function () {
        st.applied = false; save();
        toast(T.of_na || 'This offer cannot be used on this bag.');
        post((C.root || '/') + 'cart/update.js', { discount: '' }).catch(function () {});
      });
  }
  function drop() {
    if (!st.applied) return;
    st.applied = false; save();
    post((C.root || '/') + 'cart/update.js', { discount: '' }).then(function () { if (drawer() && drawer().classList.contains('active')) refreshBag(); }).catch(function () {});
  }
  var timer = null;
  function tick() {
    clearInterval(timer);
    timer = setInterval(function () {
      if (!live()) { clearInterval(timer); drop(); paintOffer(); closeExit(); return; }
      document.querySelectorAll('[data-jz-left]').forEach(function (el) { el.textContent = left(); });
    }, 1000);
  }
  function card(where) {
    var lab = O.label || '10%';
    if (st.applied) return '<div class="jzo jzo--' + where + ' is-on"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><p><b>' + (T.of_on || 'Your offer is on') + ' · ' + lab + '</b><span>' + (T.of_ends || 'Ends in') + ' <i data-jz-left>' + left() + '</i></span></p></div>';
    var title = where === 'pdp' ? (T.of_pdp || 'Back for this one?') : (T.of_bag || 'Just for you');
    return '<div class="jzo jzo--' + where + '"><p><small>' + title + '</small><b>' + lab + ' ' + (T.of_off || 'off') + '</b><span>' + (T.of_ends || 'Ends in') + ' <i data-jz-left>' + left() + '</i></span></p><button type="button" class="jzo__btn" data-jz-offer-apply>' + (T.of_apply || 'Apply') + '</button></div>';
  }
  function paintOffer() {
    var on = live();
    document.querySelectorAll('[data-jz-offer-slot]').forEach(function (s) { s.innerHTML = on ? card('bag') : ''; });
    document.querySelectorAll('[data-jz-offer-pdp]').forEach(function (s) { s.innerHTML = on ? card('pdp') : ''; });
  }
  function toast(msg, action) {
    var t = document.querySelector('.jzo-toast'); if (t) t.remove();
    t = document.createElement('div'); t.className = 'jzo-toast'; t.setAttribute('role', 'status');
    t.innerHTML = '<p>' + msg + '</p>' + (action ? '<button type="button">' + action.label + '</button>' : '') + '<button type="button" class="jzo-toast__x" aria-label="Close">×</button>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    t.addEventListener('click', function (e) {
      if (e.target.classList.contains('jzo-toast__x')) { t.remove(); return; }
      if (action && e.target.tagName === 'BUTTON') { t.remove(); action.run(); }
    });
    setTimeout(function () { if (t.isConnected) t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, action ? 14000 : 5000);
  }
  var exitEl = null;
  function closeExit() { if (exitEl) { exitEl.close ? exitEl.close() : 0; exitEl.remove(); exitEl = null; } }
  function exitModal(count) {
    if (exitEl) return;
    exitEl = document.createElement('dialog'); exitEl.className = 'jzo-exit';
    exitEl.innerHTML = '<div class="jzo-exit__in"><p class="jzo-exit__k">' + (T.of_bag || 'Just for you') + '</p><p class="jzo-exit__h">' + (O.label || '10%') + ' ' + (T.of_off || 'off') + '</p><p class="jzo-exit__s">' + (count ? (T.of_exit_bag || 'Finish your order now and it is yours.') : (T.of_exit_view || 'Saved for you. Add anything to your bag.')) + '</p><p class="jzo-exit__t">' + (T.of_ends || 'Ends in') + ' <i data-jz-left>' + left() + '</i></p><div class="jzo-exit__btns"><button type="button" class="jzo-exit__go" data-go>' + (count ? (T.of_checkout || 'Apply & checkout') : (T.of_keep || 'Apply & keep shopping')) + '</button><button type="button" class="jzo-exit__no" data-no>' + (T.of_no || 'No thanks') + '</button></div></div>';
    document.body.appendChild(exitEl);
    if (exitEl.showModal) exitEl.showModal(); else exitEl.setAttribute('open', '');
    exitEl.addEventListener('click', function (e) {
      if (e.target === exitEl || e.target.closest('[data-no]')) closeExit();
      else if (e.target.closest('[data-go]')) { var c = count; closeExit(); apply(c ? 'checkout' : null); }
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jz-offer-apply]')) { e.preventDefault(); apply(); }
  });

  function offers() {
    if (!O.code) return;
    var count = +C.count || 0;
    // private link: /discount/CODE?redirect=/products/x%3Ffor%3DSarah
    var who = (new URLSearchParams(location.search)).get('for');
    if (who && !ses.get('jz_for')) { ses.set('jz_for', '1'); toast((T.of_hello || 'Welcome') + ' ' + who.replace(/[^\w\s'-]/g, '').slice(0, 24) + ' · ' + (T.of_private || 'your private offer is saved to your bag.')); }

    if (count > 0 && !st.bagAt) { st.bagAt = now(); save(); }
    if (!count) { st.bagAt = 0; save(); }

    // 1. coming back to the same product
    if (C.product) {
      var seen = ses.get('jz_v_' + C.product);
      if (!seen) { ses.set('jz_v_' + C.product, '1'); st.v[C.product] = (st.v[C.product] || 0) + 1; save(); }
      if (O.views && st.v[C.product] >= O.views) grant('repeat');
    }
    // 2. back to a bag left over an hour ago (once per visit)
    if (O.back && count > 0 && st.bagAt && now() - st.bagAt > 36e5 && !ses.get('jz_back')) {
      ses.set('jz_back', '1');
      if (grant('back')) toast((T.of_back || 'Your bag is still here.') + ' ' + (O.label || '10%') + ' ' + (T.of_off || 'off') + ' · <i data-jz-left>' + left() + '</i>', { label: T.of_open || 'Open bag', run: function () { refreshBag(); } });
    }
    // 3. lingering in the bag without checking out
    if (O.bagSecs) {
      var wait = null;
      var watch = function () {
        var d = drawer(); var open = (d && d.classList.contains('active')) || C.page === 'cart';
        if (open && !wait) wait = setTimeout(function () { cartJS().then(function (c) { if (c.item_count && grant('bag')) paintOffer(); }); }, O.bagSecs * 1000);
        if (!open && wait) { clearTimeout(wait); wait = null; }
      };
      var d0 = drawer(); if (d0) new MutationObserver(watch).observe(d0, { attributes: true, attributeFilter: ['class'] });
      watch();
    }
    // 4. leaving (desktop): pointer out through the top after a little while
    if (O.exit && matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var since = now();
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 6 || now() - since < 12000 || ses.get('jz_exit')) return;
        var viewed = Object.keys(st.v).length;
        cartJS().then(function (c) {
          if (!c.item_count && viewed < 2) return;
          ses.set('jz_exit', '1');
          if (grant('exit')) exitModal(c.item_count);
        });
      });
    }
    // drawer re-renders replace the slot: paint again
    var d1 = drawer(); if (d1) new MutationObserver(function () { if (live()) { var s = d1.querySelector('[data-jz-offer-slot]'); if (s && !s.firstChild) paintOffer(); } }).observe(d1, { childList: true, subtree: true });
    if (live()) { paintOffer(); tick(); }
    else if (st.applied) drop();
  }

  /* ---------- Judge.me store rating above the title ----------
     Judge.me's review widget (an app block lower on the page) carries the live store totals:
     data-shop-average-rating / data-shop-review-count. Nothing is shown without them. */
  function judgeme() {
    var el = document.querySelector('[data-jz-jm]'); if (!el || !el.hidden) return;
    var w = document.querySelector('[data-shop-review-count][data-shop-average-rating]'); if (!w) return;
    var n = parseInt(w.getAttribute('data-shop-review-count'), 10) || 0;
    var r = parseFloat(w.getAttribute('data-shop-average-rating')) || 0;
    if (!n || !r) return;
    el.querySelector('[data-jm-rating]').textContent = r.toFixed(1);
    el.querySelector('[data-jm-count]').textContent = n + ' ' + (n === 1 ? (T.jm_review || 'review') : (T.jm_reviews || 'reviews'));
    el.querySelector('[data-jm-fill]').style.width = Math.min(100, r / 5 * 100) + '%';
    el.setAttribute('aria-label', r.toFixed(1) + ' / 5, ' + n + ' reviews on Judge.me');
    el.hidden = false;
  }

  /* ---------- product thumbnails (desktop): column as tall as the main photo; keep the chosen one in view ---------- */
  function thumbs(scope) {
    (scope || document).querySelectorAll('.product__media-list').forEach(function (list) {
      var main = list.querySelector('.main-carousel'), rail = list.querySelector('.thumbnail-carousel .splide__track');
      if (!main || !rail || rail.__jz) return; rail.__jz = true;
      function fit() { var h = main.getBoundingClientRect().height; if (h > 80) list.style.setProperty('--jz-main-h', Math.round(h) + 'px'); }
      fit(); window.addEventListener('resize', fit);
      if (window.ResizeObserver) new ResizeObserver(fit).observe(main);
      new MutationObserver(function () {
        var on = rail.querySelector('.splide__slide.is-active'); if (!on) return;
        var top = on.offsetTop, bottom = top + on.offsetHeight;
        if (top < rail.scrollTop || bottom > rail.scrollTop + rail.clientHeight) rail.scrollTo({ top: Math.max(0, top - rail.clientHeight / 2 + on.offsetHeight / 2), behavior: 'smooth' });
      }).observe(rail, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });
  }

  /* ---------- phone menu: one department at a time, with a back arrow ---------- */
  function drawerNav() {
    if (document.__jzd) return; document.__jzd = true;
    document.addEventListener('toggle', function (e) {
      var d = e.target; if (!d.matches || !d.matches('.jzd__dept > details')) return;
      var nav = d.closest('[data-jzd]'), li = d.parentNode;
      if (d.open) {
        nav.querySelectorAll('.jzd__dept > details[open]').forEach(function (x) { if (x !== d) x.open = false; });
        nav.classList.add('is-sub'); li.classList.add('is-on');
        var sc = nav.closest('.menu-drawer__inner-container, .menu-drawer, .drawer__inner') || nav.parentNode; if (sc && sc.scrollTo) sc.scrollTo({ top: 0 });
      } else {
        li.classList.remove('is-on');
        if (!nav.querySelector('.jzd__dept > details[open]')) nav.classList.remove('is-sub');
      }
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jzd-back]'); if (!b) return;
      var d = b.closest('details'); if (d) d.open = false;
    });
  }
  /* option labels written in capitals ("SIZE") read as "Size" */
  function tidyLabels(scope) {
    (scope || document).querySelectorAll('.product__info-container .form__label').forEach(function (l) {
      var n = l.firstChild; if (!n || n.nodeType !== 3) return;
      var s = n.textContent; if (/[A-Z]{3,}/.test(s) && s === s.toUpperCase()) n.textContent = s.charAt(0) + s.slice(1).toLowerCase();
    });
  }

  /* ---------- all Judge.me reviews (store-wide) in the reviews section ----------
     Judge.me only allows its all-reviews carousel on pages like the home page, so it lives in
     templates/index.jz-reviews.json and is fetched here when the section comes near. */
  function allReviews(scope) {
    (scope || document).querySelectorAll('[data-jz-allreviews]').forEach(function (slot) {
      if (slot.__jz) return; slot.__jz = true;
      var sec = slot.closest('.jzr');
      function load() {
        fetch((C.root || '/') + '?view=jz-reviews').then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var w = doc.querySelector('.jdgm-cards-carousel'); if (!w) return;
          var block = w.closest('.shopify-app-block') || w.parentNode;
          slot.innerHTML = block.innerHTML;
          // scripts added through innerHTML don't run: re-create them (Judge.me's carousel settings live there)
          slot.querySelectorAll('script').forEach(function (old) {
            var s = document.createElement('script');
            if (old.type) s.type = old.type;
            if (old.src) s.src = old.src; else s.textContent = old.textContent;
            old.parentNode.replaceChild(s, old);
          });
          var car = slot.querySelector('.jdgm-cards-carousel'); car.classList.remove('jdgm-hidden');
          // Judge.me's loader only fetches the carousel helpers for carousels present at page load
          // (Shopify only adds the carousel's own carousels.js when the block is on the page itself)
          var jb = window.jdgm && window.jdgm.CDN_BASE_URL;
          if (jb && !window.jdgmCarouselUtils && !document.querySelector('script[src="' + jb + 'carousels.js"]')) {
            var cs = document.createElement('script'); cs.src = jb + 'carousels.js'; document.head.appendChild(cs);
          }
          if (window.jdgm && window.jdgm.loadScript && window.jdgm.CDN_HOST && !window.jdgmCarouselUtils) {
            try { window.jdgm.loadScript(window.jdgm.CDN_HOST + 'widget/others.js'); } catch (x) {}
          }
          // let Judge.me's own widget script fill the cards, the way its loader does
          var base = window.jdgm && window.jdgm.CDN_BASE_URL, ep = car.getAttribute('data-entry-point');
          if (base && ep) {
            var src = base + ep;
            if (!document.querySelector('script[src="' + src + '"]')) { var sc = document.createElement('script'); sc.type = 'module'; sc.src = src; document.head.appendChild(sc); }
          }
          var track = slot.querySelector('.jdgm-cards-wrapper');
          slot.querySelectorAll('.jdgm-arrow').forEach(function (a, i) {
            a.addEventListener('click', function () { if (track) track.scrollBy({ left: (i === 0 ? -1 : 1) * track.clientWidth * 0.8, behavior: 'smooth' }); });
          });
          if (sec) sec.classList.add('has-all');
        }).catch(function () {});
      }
      var done = false;
      function once() { if (done) return; done = true; load(); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); once(); } }, { rootMargin: '600px' });
        io.observe(slot);
      }
      // and in any case shortly after the page has loaded
      if (document.readyState === 'complete') setTimeout(once, 3000);
      else window.addEventListener('load', function () { setTimeout(once, 3000); });
    });
  }

  /* ---------- collection header: background from the crest's own colours ----------
     Draw the crest small on a canvas, keep the strong pixels (not white, black or grey),
     group them by hue and use the two or three biggest groups, deepened so white text stays readable. */
  function tint(scope) {
    (scope || document).querySelectorAll('[data-jz-tint]').forEach(function (el) {
      if (el.__jz) return; el.__jz = true;
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'), W = 48, H = 48; c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, W, H);
          var d = x.getImageData(0, 0, W, H).data, groups = {};
          for (var i = 0; i < d.length; i += 4) {
            var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
            if (a < 200) continue;
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2 / 255, sat = mx === mn ? 0 : (mx - mn) / 255;
            if (sat < 0.22 || l > 0.9 || l < 0.08) continue;
            var k = Math.round(rgbHue(r, g, b) / 24) % 15;
            var gr = groups[k] || (groups[k] = { n: 0, r: 0, g: 0, b: 0 });
            gr.n++; gr.r += r; gr.g += g; gr.b += b;
          }
          var list = Object.keys(groups).map(function (k) { var gr = groups[k]; return { n: gr.n, r: gr.r / gr.n, g: gr.g / gr.n, b: gr.b / gr.n }; })
            .filter(function (gr) { return gr.n > 12; }).sort(function (a, b) { return b.n - a.n; }).slice(0, 3);
          if (!list.length) return;
          // darkest colour leads (the base), the lightest (often gold trim) is only a small accent
          list.sort(function (p, q) { return (p.r * .3 + p.g * .59 + p.b * .11) - (q.r * .3 + q.g * .59 + q.b * .11); });
          var cols = list.map(function (gr) { return deepen(gr.r, gr.g, gr.b); });
          el.style.setProperty('--t1', cols[0].mid);
          el.style.setProperty('--t2', (cols[1] || cols[0]).mid);
          el.style.setProperty('--t3', (cols[2] || cols[1] || cols[0]).mid);
          el.style.setProperty('--tbg', cols[0].deep);
          el.classList.add('is-tinted');
        } catch (e) {}
      };
      img.src = el.getAttribute('data-jz-tint');
    });
  }
  function rgbHue(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, dd = mx - mn;
    if (!dd) return 0;
    if (mx === r) h = ((g - b) / dd) % 6; else if (mx === g) h = (b - r) / dd + 2; else h = (r - g) / dd + 4;
    h *= 60; return h < 0 ? h + 360 : h;
  }
  function deepen(r, g, b) {
    var h = rgbHue(r, g, b), mx = Math.max(r, g, b) / 255, mn = Math.min(r, g, b) / 255;
    var l = (mx + mn) / 2, s = mx === mn ? 0 : (mx - mn) / (1 - Math.abs(2 * l - 1));
    s = Math.min(0.85, Math.max(0.45, s));
    return {
      mid: 'hsl(' + Math.round(h) + ' ' + Math.round(s * 100) + '% ' + Math.round(Math.min(0.46, Math.max(0.32, l)) * 100) + '%)',
      deep: 'hsl(' + Math.round(h) + ' ' + Math.round(s * 80) + '% 12%)'
    };
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-jz-sg]').forEach(sizeGuide);
    scope.querySelectorAll('[data-jz-custom]').forEach(custom);
    thumbs(scope);
    tint(scope);
    allReviews(scope);
    tidyLabels(scope);
  }
  function boot() { init(); offers(); drawerNav(); judgeme(); setTimeout(judgeme, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
